import React from 'react';
import { Eye, BookOpen } from 'lucide-react';
import FormModal from './FormModal';

interface Guidance {
  id: number;
  title: string;
  description: string;
  content: string;
  category: string;
  framework_id?: number;
  scope_id?: number;
  section_id?: number;
  page_id?: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

interface GuidancePreviewModalProps {
  onClose: () => void;
  guidance: Guidance;
}

export const GuidancePreviewModal: React.FC<GuidancePreviewModalProps> = ({
  onClose,
  guidance,
}) => {
  return (
    <FormModal
      title={`Preview: ${guidance.title}`}
      subtitle="See how your guidance will appear"
      icon={<Eye className="text-white" size={24} />}
      onSubmit={() => {}} // No submit action for preview
      onCancel={onClose}
      cancelText="Close"
      showSubmitButton={false}
      size="large"
    >
      <div className="space-y-6">
        <div className="bg-slate-50 rounded-xl p-6">
          <div className="flex items-start gap-4">
            <div className="p-3 bg-blue-100 rounded-xl">
              <BookOpen className="text-blue-600" size={24} />
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-semibold text-slate-900 mb-2">{guidance.title}</h3>
              <p className="text-slate-600 mb-4">{guidance.description}</p>

              <div className="flex items-center gap-4 text-sm text-slate-500 mb-4">
                <span className="flex items-center gap-1">
                  <span className="font-medium">Category:</span> {guidance.category}
                </span>
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                  guidance.is_active
                    ? 'bg-emerald-100 text-emerald-700'
                    : 'bg-slate-100 text-slate-700'
                }`}>
                  {guidance.is_active ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-200 pt-6">
          <h4 className="text-lg font-semibold text-slate-900 mb-4">Content</h4>
          <div className="prose prose-slate max-w-none">
            <div dangerouslySetInnerHTML={{ __html: guidance.content }} />
          </div>
        </div>
      </div>
    </FormModal>
  );
};